import React from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import {
  FALLBACK_STATUS_BADGE,
  TICKET_STATUS_COLORS,
} from "../config/status-colors";

interface TicketStatusBadgeProps {
  status: string;
  className?: string;
}

/**
 * Statü rozeti — renk/i18n eşlemesi status-colors config'inden gelir;
 * bilinmeyen değerler nötr fallback ile ham haliyle gösterilir.
 */
export const TicketStatusBadge: React.FC<TicketStatusBadgeProps> = ({
  status,
  className,
}) => {
  const { t } = useTranslation();
  const config = TICKET_STATUS_COLORS[status];

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        config?.badge ?? FALLBACK_STATUS_BADGE,
        className,
      )}
    >
      {config ? t(config.i18nKey) : status}
    </span>
  );
};
